import { Nullable } from "@tager/admin-services";
import { OptionType } from "@tager/admin-ui";

import { FullProductTypeType, ProductTypeType } from "@/typings/model";
import {
  ProductTypeCreationPayload,
  ProductTypeUpdatePayload,
} from "@/services/requests";

export type FormValues = {
  name: string;
  systemName: string;
  category: Nullable<OptionType<number>>;
};

export function convertProductTypeToFormValues(
  productType: Nullable<FullProductTypeType>,
  categoryOptionList: Array<OptionType<number>>
): FormValues {
  if (!productType) {
    return {
      name: "",
      systemName: "",
      category: null,
    };
  }

  const currentCategoryOption = categoryOptionList.find(
    (categoryOption) => categoryOption.value === productType.defaultCategoryId
  );

  return {
    name: productType.name ?? "",
    systemName: productType.systemName ?? "",
    category: currentCategoryOption ?? null,
  };
}

export function convertFormValuesToProductTypeCreationPayload(
  values: FormValues
): ProductTypeCreationPayload {
  return {
    name: values.name ?? "",
    systemName: values.systemName ?? "",
  };
}

export function convertFormValuesToProductTypeUpdatePayload(
  values: FormValues
): ProductTypeUpdatePayload {
  return {
    defaultCategoryId: values.category?.value ?? null,
    ...convertFormValuesToProductTypeCreationPayload(values),
  };
}
